<template>
  <b-sidebar
    id="sidebar-1"
    right
    width="30vw"
    shadow
    :visible="visibility"
    body-class="bodyStyle"
    @change="changeVisibility"
  >
    <!-- <vue-perfect-scrollbar
      :settings="scroll_settings"
      class="scroll-area"
    > -->
    <div
      class="d-flex flex-column align-items-center justify-content-center px-3 py-2"
    >
      <h3>{{ $t("objects.appertment") }}</h3>
      <div class="d-flex w-100 mb-1">
        <div class="w-50 p-50">
          <b-img
            style="cursor: pointer"
            :src="item.image_2d"
            fluid
            thumbnail
            @click="$emit('photoClicked', item.image_2d)"
          />
          <p class="text-center">
            {{ $t("objects.layout") }}
          </p>
        </div>
        <div class="w-50 p-50">
          <b-img
            style="cursor: pointer"
            :src="item.image_3d"
            fluid
            class="h-100"
            thumbnail
            @click="$emit('photoClicked', item.image_3d)"
          />
          <p class="text-center">
            {{ $t("objects.3d_planning") }}
          </p>
        </div>
      </div>
      <!-- <b-button
        variant="primary"
        @click="left_sidebar = false"
      >
        <feather-icon
          variant
          icon="FileIcon"
        />
        Заявка на квартиру
      </b-button> -->
      <div class="d-flex justify-content-center align-items-end mt-2">
        <b-badge class="p-75 mr-50" :variant="item.current_status.color">
          {{ " " }}
        </b-badge>
        <span v-if="item.current_status.title">
          {{ item.current_status.title[$i18n.locale] }}
        </span>
      </div>
      <div class="text-center mt-2">
        {{ item.contract_number }}
      </div>
      <div class="w-100 mt-2">
        <!-- <div class="d-flex py-1 border-top justify-content-between align-items-center">
            <span class="text-secondary m-0">
              {{ $t('objects.appertment_id') }}
            </span>
            <span class="m-0">
              {{ item.id }}
            </span>
          </div> -->
        <div
          class="d-flex py-1 border-top justify-content-between align-items-center"
        >
          <span class="text-secondary m-0">
            {{ $t("objects.apertment_number") }}
          </span>
          <span class="m-0">
            {{ item.flat_number }}
          </span>
        </div>
        <div
          class="d-flex py-1 border-top justify-content-between align-items-center"
        >
          <span class="text-secondary m-0">
            {{ $t("objects.floor") }}
          </span>
          <span class="m-0">
            {{ item.stage_floor }}
          </span>
        </div>
        <div
          class="d-flex py-1 border-top justify-content-between align-items-center"
        >
          <span class="text-secondary m-0">
            {{ $t("objects.entrance") }}
          </span>
          <span class="m-0">
            {{ item.section_title }}
          </span>
        </div>
        <div
          class="d-flex py-1 border-top justify-content-between align-items-center"
        >
          <span class="text-secondary m-0">
            {{ $t("objects.numbers_room") }}
          </span>
          <span class="m-0">
            {{ item.rooms_count }}
          </span>
        </div>
        <div
          class="d-flex py-1 border-top justify-content-between align-items-center"
        >
          <span class="text-secondary m-0">
            {{ $t("objects.selling_price") }}
          </span>
          <span class="m-0">
            {{ $_moneyFormatter(item.total_price) }}
          </span>
        </div>
        <div
          class="d-flex py-1 border-top justify-content-between align-items-center"
        >
          <span class="text-secondary m-0">
            {{ $t("objects.price_per_m") }}
          </span>
          <span class="m-0">
            {{ $_moneyFormatter(item.price_per_kv) }}
          </span>
        </div>
        <div class="py-1 border-top mb-2">
          <div class="d-flex justify-content-between">
            <b class="text-secondary m-0"> {{ $t("objects.area_m") }}: </b>
            <b> {{ item.total_area }} м² </b>
          </div>
          <div class="pl-1">
            <div
              v-for="(area_field, index) in getLivingAreas"
              :key="index"
              class="d-flex justify-content-between mt-50"
            >
              <span class=""
                >{{ index + 1 }}. {{ area_field.title[$i18n.locale] }}</span
              >
              <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
              <span class="ml-auto">{{ area_field.value }} м² </span>
            </div>
            <hr class="my-75" />
            <div
              v-for="(area_field, index) in getNonLivingAreas"
              :key="index"
              class="d-flex justify-content-between mt-50"
            >
              <span class=""
                >{{ index + 1 + getLivingAreas.length }}.
                {{ area_field.title[$i18n.locale] }}</span
              >
              <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
              <span class="ml-auto">{{ area_field.value }} м² </span>
            </div>
          </div>
        </div>
        <div class="py-1 border-top">
          <span class="text-secondary m-0">
            {{ $t("objects.specifications") }}:
          </span>
          <ul class="mt-50">
            <li v-for="property in item.characteristics" :key="property.id">
              {{ property.title[$i18n.locale] }}
            </li>
          </ul>
        </div>
        <div class="py-1 border-top">
          <span class="text-secondary m-0">
            {{ $t("objects.description") }}:
          </span>
          <p v-if="item.description">
            {{ item.description[$i18n.locale] }}
          </p>
        </div>
        <div class="py-1 border-top mb-1">
          <span class="text-secondary m-0">
            {{ $t("objects.additional_fields") }}:
          </span>
          <div class="pl-1">
            <div class="d-flex justify-content-between mt-50">
              <span class="">{{ $t("objects.studio") }}</span>
              <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
              <feather-icon
                v-if="item.is_studio"
                class="ml-auto text-success"
                icon="CheckSquareIcon"
              />
              <feather-icon v-else class="ml-auto text-danger" icon="XIcon" />
            </div>
            <div class="d-flex justify-content-between mt-50">
              <span class="">{{ $t("objects.builders_layout") }}</span>
              <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
              <feather-icon
                v-if="item.is_euro_planning"
                class="ml-auto text-success"
                icon="CheckSquareIcon"
              />
              <feather-icon v-else class="ml-auto text-danger" icon="XIcon" />
            </div>
            <div class="d-flex justify-content-between mt-50">
              <span class="">{{ $t("objects.free_layout") }}</span>
              <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
              <feather-icon
                v-if="item.is_free_planning"
                class="ml-auto text-success"
                icon="CheckSquareIcon"
              />
              <feather-icon v-else class="ml-auto text-danger" icon="XIcon" />
            </div>
            <div class="d-flex justify-content-between mt-50">
              <span class="">{{ $t("objects.where_window_to") }}</span>
              <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
              <span
                v-if="item.output_window && item.output_window.title"
                class="ml-auto text-success"
              >
                {{ item.output_window.title[$i18n.locale] }}
              </span>
              <span v-else class="ml-auto">
                {{ $t("objects.no_data") }}
              </span>
            </div>
          </div>
        </div>
        <div class="py-1 border-top">
          <div class="d-flex justify-content-between mt-50">
            <span class="">{{ $t("objects.calculations_discount") }}:</span>
            <div class="border-dotted-bottom mb-25 mx-25 flex-grow-1" />
            <span class="ml-auto"
              ><b-button
                class="p-0"
                variant="link"
                @click="openCalculationsModal(item.id)"
                >{{ $t("generals.show") }}</b-button
              ></span
            >
          </div>
        </div>
        <div
          v-if="item.current_status.id !== flat_statuses.occupied"
          class="d-flex justify-content-around"
        >
          <!-- flat status hardcode -->
          <b-button
            v-if="
              item.current_status.id !== flat_statuses.sold && !flatChoosing
            "
            variant="primary"
            @click="makeContract(item)"
          >
            {{ $t("objects.enter_contract") }}
          </b-button>
          <b-button
            v-if="
              item.current_status.id === flat_statuses.sold && !flatChoosing
            "
            variant="primary"
            @click="oformit(item)"
          >
            {{ $t("objects.register") }}
          </b-button>
          <!-- v-if="item.current_status.id === 3" -->
          <b-button
            v-if="
              [flat_statuses.sold, flat_statuses.occupied].includes(
                item.current_status.id,
              )
            "
            variant="primary"
            @click="$_downloadInterval(item.contract)"
          >
            {{ $t("objects.download_contract") }}
          </b-button>
          <b-button
            v-if="flatChoosing"
            variant="primary"
            @click="$emit('flatChoose', item.id)"
          >
            {{ $t("objects.select") }}
          </b-button>
          <b-button
            v-if="
              item.current_status.id === flat_statuses.available &&
                !item.not_allowed_to_book
            "
            variant="primary"
            v-b-modal.kp-percentage-modal
          >
            {{ $t("objects.download_kp") }}
          </b-button>
        </div>
        <div
          v-if="!item.bron_employee"
          class="d-flex justify-content-around mt-1"
        >
          <!-- flat status hardcode -->
          <b-button
            v-if="item.current_status.id === flat_statuses.available"
            variant="info"
            @click="interestedIn(item.id)"
          >
            {{ $t("objects.interest") }}
          </b-button>
          <!-- <b-button
              v-if="item.current_status.id === flat_statuses.available && !item.not_allowed_to_book"
              variant="warning"
              @click="bookTheFlat(item.id)"
            >
              {{ $t('objects.book_for_ten_days') }}
            </b-button> -->
        </div>
        <div
          v-else
          class="d-flex align-items-center justify-content-between mt-1"
        >
          <span class="text-secondary m-0"> {{ $t("Забронировано") }}: </span>
          <span class="m-0 d-flex align-items-center">
            {{ item.bron_employee.name }}
            <button
              class="btn btn-outline ml-1 text-danger"
              @click="unBookFlat"
            >
              <feather-icon icon="XIcon" size="22" />
            </button>
          </span>
        </div>
      </div>
    </div>
    <!-- </vue-perfect-scrollbar> -->
    <calculations-modal v-if="flat_id_to_calc" :flat_id="flat_id_to_calc" />
    <KPModal @percentageSelected="downloadCommercialOffer" />
    <b-overlay :show="overlay" no-wrap />

    <b-modal
      id="select-client-modal"
      cancel-variant="outline-secondary"
      :ok-title="$t('generals.select')"
      :title="$t('Выберите клиента')"
      :cancel-title="$t('generals.cancel')"
      centered
      no-close-on-backdrop
      @ok.prevent="bookTheFlat"
    >
      <b-form-group :label="$t('clients.manager') + ':'">
        <LazySelect
          v-model="selected_client"
          :options="GET_EMPLOYEE"
          :get-option-label="(user) => user.name"
          :fetch="FETCH_EMPLOYEE"
          :reduce="(user) => user.id"
          class="bg-white"
        />
      </b-form-group>
    </b-modal>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BOverlay,
  BImg,
  BBadge,
  BButton,
  VBModal,
  BModal,
  BFormGroup,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import { mapActions } from "vuex";
import formatters from "@/mixins/extra";
import CalculationsModal from "./modals/calculationsModal.vue";
import download from "@/mixins/download";
import flatStatuses from "@/mixins/flat_statuses";
import KPModal from "./modals/KPModal.vue";
import { mapGetters } from "vuex/dist/vuex.common.js";
import LazySelect from "@/components/LazySelect.vue";

export default {
  components: {
    BSidebar,
    BImg,
    BBadge,
    FeatherIcon,
    BButton,
    BOverlay,
    CalculationsModal,
    KPModal,
    BModal,
    BFormGroup,
    LazySelect,
  },
  mixins: [formatters, download, flatStatuses],
  model: {
    prop: "visibility",
    event: "changed",
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    visibility: {
      type: null,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    flatChoosing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      overlay: false,
      flat_id_to_calc: null,
      // visibility: this.value,
      scroll_settings: {
        wheelPropagation: false,
        // minScrollbarLength: 200,
        // maxScrollbarLength: 300,
        wheelSpeed: 3,
        swipeEasing: true,
      },
      selected_client: null,
      flat_id: null,
    };
  },
  computed: {
    ...mapGetters("clients", ["GET_EMPLOYEE"]),
    getLivingAreas() {
      if (this.item.areas) {
        return this.item.areas.filter((el) => el.is_living);
      }
      return [];
    },
    getNonLivingAreas() {
      if (this.item.areas) {
        return this.item.areas.filter((el) => !el.is_living);
      }
      return [];
    },
  },
  methods: {
    ...mapActions("flats", ["EDIT_FLAT", "GET_FLAT_CO_FILE"]),
    ...mapActions("clients", ["FETCH_EMPLOYEE"]),
    ...mapActions("apartments", ["BOOK_FLAT", "UNBRON_FLAT"]),

    changeVisibility(e) {
      console.log(e);
      this.$emit("changed", e);
    },
    openCalculationsModal(id) {
      console.log(id);
      this.flat_id_to_calc = id;
      this.$nextTick(() => {
        this.$bvModal.show("calc-modal");
      });
    },
    bookTheFlat() {
      // this.$emit("bookingFlat", id);
      this.BOOK_FLAT({
        flat: this.flat_id,
        client: this.selected_client,
      })
        .then(() => {
          this.$bvModal.hide("select-client-modal");
          this.$_successToast(this.$t("generals.succesfuly"));
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        });
    },
    interestedIn(flat_id) {
      this.flat_id = flat_id;
      this.$bvModal.show("select-client-modal");
    },
    downloadCommercialOffer(percentageSelected) {
      this.overlay = true;
      this.$emit("commercialOffer", this.item.id);
      this.GET_FLAT_CO_FILE({
        id: this.item.id,
        payment_in_percent: percentageSelected,
      }).then((res) => {
        // const url = window.URL.createObjectURL(new Blob([res.data]))
        console.log(res);
        const link = document.createElement("a");
        link.href = res.data.url;
        link.setAttribute(
          "download",
          `${this.item.apartment_title}-${this.item.id}.pdf`,
        ); // or any other extension
        document.body.appendChild(link);
        link.target = "_blank";
        link.click();
        this.$bvModal.hide("kp-percentage-modal");
        this.overlay = false;
      });
    },
    makeContract(item) {
      this.$emit("makeContract", item);
      sessionStorage.setItem("selected_flat", item.id);
      this.$router.push({ name: "new-contract" });
    },
    oformit(item) {
      this.$emit("oformit", item.id);
    },
    unBookFlat() {
      this.overlay = true;
      this.UNBRON_FLAT(this.item.bron_employee.id)
        .then(() => {
          this.$_successToast(this.$t("generals.succesfuly"));
          this.$emit("updated");
          this.item.bron_employee = null;
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>

<style>
.border-dotted-bottom {
  border-bottom: 1px dotted rgb(174, 174, 174);
}
.scroll-area {
  position: relative;
  margin: auto;
  /* // width: 110%; */
  height: 100%;
  overflow-y: hidden;
  /* // scroll-behavior: smooth; */
}

[dir="ltr"] #sidebar-1 ::-webkit-scrollbar-track {
  background: #f6f6f6;
}

[dir="ltr"] #sidebar-1 ::-webkit-scrollbar-thumb {
  background: #dddddd;
}
</style>
